import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from './IssueNode.mjs';
import {
  ValidatedSetLens3tjmcbmmtgp0c as ValidatedSetLens,
  ValidatedModifyLensxnr6y4izl6zn as ValidatedModifyLens,
} from './validationLenses.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { MutableValidated2ognu5vxf17ur as MutableValidated } from './Validated.mjs';
import {
  MutableReactive2qdhhyljdknhy as MutableReactive,
  MutableValue2jbqb2a7km3rc as MutableValue,
} from '../../core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function validated(_this__u8e3s4, reportTo) {
  reportTo = reportTo === VOID ? null : reportTo;
  return new (RootValidatedDraft())(_this__u8e3s4, reportTo);
}
var RootValidatedDraftClass;
function RootValidatedDraft() {
  if (RootValidatedDraftClass === VOID) {
    class $ {
      constructor(draft, reportTo) {
        reportTo = reportTo === VOID ? null : reportTo;
        this.draft_1 = draft;
        var tmp = this;
        var tmp1_elvis_lhs = reportTo == null ? null : reportTo.child$default_s9je3b_k$();
        tmp.node_1 = tmp1_elvis_lhs == null ? new (IssueNode())() : tmp1_elvis_lhs;
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      lens_drj4fu_k$(get, set) {
        return ValidatedSetLens().new_com_lightningkite_reactive_lensing_validation_ValidatedSetLens_tc311d_k$(this, get, set);
      }
      lens_u4wb4z_k$(get, modify) {
        return ValidatedModifyLens().new_com_lightningkite_reactive_lensing_validation_ValidatedModifyLens_n91gng_k$(this, get, modify);
      }
      get_published_wg9pad_k$() {
        return this.draft_1.get_published_wg9pad_k$();
      }
      *publish_xq9q2e_k$($completion) {
        return yield* this.draft_1.publish_xq9q2e_k$($completion);
      }
      cancel_2l89ey_k$() {
        this.draft_1.cancel_2l89ey_k$();
      }
      get_changesMade_d6j01d_k$() {
        return this.draft_1.get_changesMade_d6j01d_k$();
      }
      get_state_wc71uu_k$() {
        return this.draft_1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.draft_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.draft_1.beginUse_omrbby_k$();
      }
      *set_revjhg_k$(value, $completion) {
        yield* this.draft_1.set_revjhg_k$(value, $completion);
        return Unit_instance;
      }
      valueSet_aujvv6_k$(value) {
        this.draft_1.valueSet_aujvv6_k$(value);
      }
    }
    initMetadataForClass($, 'RootValidatedDraft', VOID, VOID, [MutableValidated(), MutableReactive(), MutableValue()], [0, 1]);
    RootValidatedDraftClass = $;
  }
  return RootValidatedDraftClass;
}
//region block: exports
export {
  validated as validated2q9ie09qg9r46,
};
//endregion

//# sourceMappingURL=ValidatedDraft.mjs.map
